import React, { useState } from "react";
import Header from "./Header";
import { custom_context } from "../../utils/custom_context";
import { getStorage } from "../../utils/storage";
import { useModalQueryParams } from "../../utils/useModalQueryParams";
import { useParams } from "react-router-dom";

export default function Layout({ children, showHeader }) {
  const { applicationId } = useParams();
  const [topbarIsOpen, setTopbarOpen] = useState(false);
  const [showKycModal, setShowKycModal] = useModalQueryParams('kyc', false);
  // User data only (from localStorage "user_session"); shape { userDetails } for compatibility
  const [profileData, setProfileData] = useState(() => {
    const stored = getStorage("user_session");
    if (!stored) return null;
    // Normalize so profileData has userDetails (stored may be { userDetails } or legacy shape)
    return stored.userDetails != null ? stored : { userDetails: stored };
  });
  // Application data: one per application; scoped to current URL applicationId.
  // User can have multiple applications; this is the one for the route /los/:applicationId/apply.
  const [applicationState, setApplicationState] = useState({ currentApplicationId: null, data: null });
  const setApplicationData = (applicationId, data) =>
    setApplicationState({ currentApplicationId: applicationId, data });

  return (
    <>
      <custom_context.ModalContext.Provider value={{ showKycModal, setShowKycModal }}>
        <custom_context.ProfileData.Provider value={{ profileData, setProfileData }}>
          <custom_context.ApplicationData.Provider
            value={{
              applicationData: applicationState.data,
              currentApplicationId: applicationState.currentApplicationId,
              setApplicationData,
            }}
          >
            {showHeader ? (
              <Header toggleTopbar={() => setTopbarOpen(!topbarIsOpen)} topbarIsOpen={topbarIsOpen} loanUUID={applicationId} />
            ) : null}
            {children}
          </custom_context.ApplicationData.Provider>
        </custom_context.ProfileData.Provider>
      </custom_context.ModalContext.Provider>
    </>
  );
}
